import { useQuery } from '@tanstack/react-query'
import * as smarLinkApi from '../../api/health/smartLink'
import { useAuthContext } from '../../hooks/useAuthContext'

const useLink = (link: string) => {
    const { user } = useAuthContext()
    
    const { isLoading: isLoadingLink, isError: isErrorLink, error: errorLink, data: linkData } = useQuery({
        queryKey: ['linkDetails', link],
        queryFn: async () => {
            const response = await smarLinkApi.getLinkMetaData(link, user.token)
            const json = await response.json()

            if (!response.ok) throw new Error(json.error)

            return json ?? null
        },
        enabled: !!link,
        retry: 0
    })

    return {
        isLoadingLink,
        isErrorLink,
        errorLink,
        linkData
    }
}

export default useLink
